import { useCallback, useEffect, useRef, useState } from "react";
import { loadGoogleMapsScript } from "utils/loadGoogleScript";

export function useGoogleAutocomplete() {
  const [autocompleteService, setAutocompleteService] =
    useState<google.maps.places.AutocompleteService | null>(null);
  const [placesService, setPlacesService] =
    useState<google.maps.places.PlacesService | null>(null);

  useEffect(() => {
    let isMounted = true;

    loadGoogleMapsScript().then(() => {
      if (!isMounted) return;

      const autoService = new window.google.maps.places.AutocompleteService();
      const places = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );

      setAutocompleteService(autoService);
      setPlacesService(places);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return { autocompleteService, placesService };
}

export const useAutocompleteSession = () => {
  const sessionRef = useRef<google.maps.places.AutocompleteSessionToken | null>(
    null
  );
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    loadGoogleMapsScript()
      .then(() => {
        if (window.google && window.google.maps) {
          sessionRef.current =
            new google.maps.places.AutocompleteSessionToken();
          setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.error("Failed to load Google Maps script:");
      });
  }, []);

  const resetSession = useCallback(() => {
    if (window.google && window.google.maps) {
      sessionRef.current = new google.maps.places.AutocompleteSessionToken();
    }
  }, []);

  const getSessionToken = useCallback(() => sessionRef.current, []);

  return {
    getSessionToken,
    resetSession,
    isLoaded,
  };
};
